import styled from 'styled-components';

export const Legend = styled.div`
  margin-top: 10px;
  li {
    list-style: none;
    color: ${(props) => props.theme.black[90]};
    img {
      margin-right: 5px;
    }
  }
  h5 {
    margin-bottom: 5px;
  }
`;
